<template>
  <div>
    <div
      style="background-color: white; padding: 20px 20px; text-align: justify"
    >
      <span style="font-size: 20px; font-weight: bolder">
        In the drug module, we have compiled basic information on 2,837 drugs
        from the LINCS project, along with drug prediction results from the
        combined analysis of perturbation transcriptomes and drug
        transcriptomes.</span
      >
      <!-- <span style="font-size: 20px; font-weight: bolder; margin-top: 10px"
        >We manually compiled a list of classic genes implicated in regulating
        tumor hallmarks through a literature review. Following this, we utilized
        the VISION package to score and evaluate these genes across single-cell
        subgroups, identifying a range of potential regulatory genes associated
        with tumor-related phenotypes. The results have been meticulously
        organized.
      </span> -->
      <div style="margin-left: 15px; font-size: 18px">
        1. A comprehensive table provides basic information on 2,837 drugs. By
        clicking on the first column, you can access detailed drug information
        and predictions regarding potential regulatory genes.
      </div>
      <div style="text-align: center; margin: 10px 0px">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/drugs1.png"
        />
      </div>
      <div style="margin-left: 15px; font-size: 18px">
        2. In the first section of the detailed page, we present detailed
        information about the drug, including its classification, known targets,
        and the compound's molecular structure.
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/drugs2.png"
        />
      </div>
      <div style="margin-left: 15px; font-size: 18px">
        3. In the second section of the detailed page, we present the drug
        prediction scores and the results of data integration. A correlation
        score above 95 is considered indicative of potential similarity.
        Furthermore, to increase reliability, we recommend conducting
        experimental explorations using drugs that have been analyzed across at
        least three datasets.
      </div>
      <div style="text-align: center; font-size: 18px">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/drugs3.png"
        />
      </div>
      <div style="margin-left: 15px; font-size: 18px">
        4. We also perform drug predictions on bulkPerturb-seq, with the results
        displayed on the detailed page. You can switch between results by
        clicking on the tabs.
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/drugs4.png"
        />
      </div>
      <a-alert
        message="The prediction results are for reference only. We recommend selecting the intersection of three or more datasets with higher scores for further experimental validation."
        banner
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
